export const TENANTS = "Tenants";

export const API_URL = process.env.VITE_APP_API_URL as string;
/** The control plane is served from its own host, not a path on `API_URL`. */
export const CONTROL_PLANE_API_URL = process.env
	.VITE_APP_CONTROL_PLANE_API_URL as string;

export const FLIPT_URL = process.env.VITE_APP_FLIPT_URL as string;
export const FLIPT_NAMESPACE = process.env.VITE_APP_FLIPT_NAMESPACE as string;

export const APP_MODE = process.env.MODE ?? "";
export const AUTH_BYPASS_REQUESTED =
	process.env.VITE_APP_AUTH_BYPASS === "true";
export const AUTH_BYPASS_ACCESS_TOKEN =
	process.env.VITE_APP_AUTH_BYPASS_TOKEN ?? "";

export const FLIPT_FLAGS = {
	"admin-tenant-pages-with-mock-data": "admin-tenant-pages-with-mock-data",
} as const;
